import { IonAvatar } from '@ionic/react';
import styled from 'styled-components';
import { AllieAvatarProps } from './Avatar.types';

export const StyledAvatar: any = styled(IonAvatar)<AllieAvatarProps>`
  ${(props: AllieAvatarProps) => (props.border ? `border: ${props.border};` : ``)}
  ${(props: AllieAvatarProps) => (props.height ? `height: ${props.height}px;` : ``)}
  ${(props: AllieAvatarProps) => (props.width ? `width: ${props.width}px;` : ``)}
`;
